'use client'

import React from 'react'
import { CollectionHeader } from './collection-header'

interface CollectionStatsProps {
	collection: any
	data: any
	slug: string
	isRemote: boolean
	hideStats?: boolean
	/** Current chart range pushed up from whichever chart instance is mounted
	 * (inline chart tab or the Insights modal). Drives the header's Change
	 * metric so its label + value match what the user sees on the chart. */
	chartRange?: { label: string; value: number } | null
	/** Callback the modal chart uses to report range changes back up. */
	onChartRangeChange?: (label: string, value: number) => void
	mode?: 'strip' | 'insights'
	onViewActivity?: () => void
	chartMaxWidth?: number
	/** Insights mode only: actions rendered beside the icon/name heading
	 * (e.g. the mobile chart/activity quick-jump icons). */
	headerLeading?: React.ReactNode
	headerActions?: React.ReactNode
}

export function CollectionStats({
	collection,
	data,
	slug,
	hideStats,
	chartRange,
	onChartRangeChange,
	mode,
	onViewActivity,
	chartMaxWidth,
	headerActions,
	headerLeading
}: CollectionStatsProps) {
	return (
		<CollectionHeader
			collection={collection}
			data={data}
			slug={slug}
			hideStats={hideStats}
			chartRange={chartRange}
			onChartRangeChange={onChartRangeChange}
			mode={mode}
			onViewActivity={onViewActivity}
			chartMaxWidth={chartMaxWidth}
			headerLeading={headerLeading}
			headerActions={headerActions}
		/>
	)
}
